import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import axios from 'axios';
import '../organiserDashboard/Modal.css';
import { ReactComponent as CloseIcon } from '../../images/icons/close.svg';
import SuccessMessage from '../helpers/successMessage';

class EditTeamMemberModal extends Component {
    constructor (props) {
        super(props);

        this.state = {
            currentSuccessMessage: '',
        };
    }

    displaySuccessMessage = message => {
        this.setState({
            currentSuccessMessage: message,
        });
    };

    resetSuccessMessage = () => {
        this.setState({
            currentSuccessMessage: '',
        });
    };

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    render () {
        const { currentSuccessMessage } = this.state;
        return (
            <div className="modal-backdrop">
                {currentSuccessMessage && (
                    <SuccessMessage message={currentSuccessMessage} resetSuccessMessage={this.resetSuccessMessage} />
                )}
                <div className="modal-padding" />
                <div className="modal-container">
                    <div className="modal-header">
                        <button className="modal-close-btn" onClick={() => this.props.toggleModal(false)}>
                            <CloseIcon />
                        </button>
                        <h2 className="modal-header-title modal-title-no-nav">Edit team member</h2>
                    </div>
                    <div className="modal-scrollable">
                        <div className="modal-content">
                            <div className="modal-content-section">
                                <p className="modal-centered-intro">
                                    Please ensure the event has not already been listed on Racecheck before submitting a
                                    request for it to be added. You can check if this is the case in the{' '}
                                    <span
                                        className="modal-content-link"
                                        title="claim-event"
                                        onClick={this.handleModalSectionChange}
                                    >
                                        claim tab
                                    </span>
                                    .
                                </p>
                                {/*eslint-disable*/}
                                {/* <form className="log-in-form" onSubmit={this.handleAddSubmit}>
                                    <div className="modal-input-row">
                                        <div className="modal-input-group">
                                            <label htmlFor="add-event-name" className="modal-input-label">Event name <span className="required-field">*</span></label>
                                            <input id="add-event-name" value={addEventName} onChange={this.handleChange} className="input modal-input" name="addEventName" type="text"></input>
                                        </div>
                                    </div>
                                    <div className="modal-input-row">
                                        <div className="modal-input-group">
                                            <label htmlFor="add-event-website" className="modal-input-label">Link to event website or event Facebook page <span className="required-field">*</span></label>
                                            <input id="add-event-website" value={addEventWebsite} onChange={this.handleChange} className="input modal-input" name="addEventWebsite" type="text"></input>
                                        </div>
                                    </div>
                                    <div className="modal-btn-row">
                                        <div role="button" className={`btn primary-btn modal-form-btn ${addEventReadyForSubmission ? "" : "disabled-primary-btn"}`} onClick={this.handleAddSubmit}>Submit request</div>
                                    </div>
                                </form> */}
                                {/* eslint-enable*/}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-padding" />
            </div>
        );
    }
}

EditTeamMemberModal.propTypes = {
    toggleModal: PropTypes.func.isRequired,
};

EditTeamMemberModal.defaultProps = {
    toggleModal: () => {},
};

export default EditTeamMemberModal;
